import { IconArrowLeft, IconFileText } from '@tabler/icons-react';
import { PageIntro } from '@/components/rides/PageIntro';
import { EmptyState, LegalDocument } from '@/components/ui';
import { useSafeBack } from '@/components/shell/useSafeBack';
import { stripUnsafeHtml } from '@/lib/sanitize';
import { useCopy, contactVars, fillPlaceholders } from '@/lib/settings';

/** Terms of use from settings.termsHtml (same sanitiser as the privacy notice), with a short summary first. */
export default function TermsPage() {
  const back = useSafeBack();
  const { t, settings } = useCopy();
  const appName = t('app.name');
  const raw = settings.termsHtml?.trim();
  // The API fills {deleteDataEmail}/{supportEmail}; fill again client-side in case it did not.
  const html = raw ? stripUnsafeHtml(fillPlaceholders(raw, contactVars(settings, appName))) : '';
  return (
    <div className="rides-main">
      <button type="button" className="rides-backlink" onClick={back}><IconArrowLeft size={20} aria-hidden="true" /> Back</button>
      <PageIntro title="Terms of use" lede={t('terms.intro')} />
      {html ? (
        <LegalDocument html={html} summary={t('terms.summary').split('\n')} />
      ) : (
        <EmptyState icon={<IconFileText size={28} />} title="Not published yet">{t('terms.missing')}</EmptyState>
      )}
    </div>
  );
}
